import { AbstractControl, ValidatorFn } from '@angular/forms';
import { emailRegexp } from '../../common';

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function emailValidator(): ValidatorFn {
  return (control: AbstractControl) => {
    if (emailRegexp.test(control.value)) {
      return undefined;
    }

    return { email: true };
  };
}
